import InstagramAnalytics from './InstagramAnalytics';

export default InstagramAnalytics;
